<p-toast key="help" position="top-right" />

<div class="help-page min-h-screen w-full flex flex-col">
  <!-- Décor de fond -->
  <div class="help-bg" aria-hidden="true">
    <span class="blob blob-1"></span>
    <span class="blob blob-2"></span>
  </div>

  <!-- Barre supérieure -->
  <header class="help-topbar">
    <button type="button" class="help-back" (click)="goBack()">
      <i class="pi pi-arrow-left"></i>
      <span>Retour</span>
    </button>

    <img [src]="logo" alt="Logo" class="help-logo logo-dark" />
    <img
      [src]="domainName.includes('ca') ? 'assets/logo_neon_ca.png' : 'assets/logo-light.svg'"
      alt="Logo"
      class="help-logo logo-light"
    />
  </header>

  <!-- Contenu -->
  <main class="help-main">
    <div class="help-card">
      <!-- ============ Écran de succès ============ -->
      <section *ngIf="success" class="help-success">
        <div class="success-icon">
          <i class="pi pi-check"></i>
        </div>
        <h1 class="success-title">Demande envoyée&nbsp;!</h1>
        <p class="success-text">
          Merci. Notre équipe support a bien reçu votre demande et vous répondra par email
          dans les plus brefs délais.
        </p>

        <div class="success-ticket" *ngIf="ticketNumber">
          <span class="success-ticket-label">Votre numéro de ticket</span>
          <span class="success-ticket-number">{{ ticketNumber }}</span>
        </div>

        <p class="success-hint">
          <i class="pi pi-envelope"></i>
          Un email de confirmation vous a été envoyé avec ce numéro.
        </p>

        <div class="success-actions">
          <button type="button" pButton severity="primary" label="Retour" [outlined]="true" (click)="goBack()"></button>
          <button type="button" pButton label="Nouvelle demande" (click)="resetForm()"></button>
        </div>
      </section>

      <!-- ============ Formulaire ============ -->
      <ng-container *ngIf="!success">
        <!-- Panneau latéral (desktop) -->
        <aside class="help-aside">
          <!-- <div class="aside-glow"></div> -->
          <div class="aside-icon">
            <i class="pi pi-headphones"></i>
          </div>
          <h2 class="aside-title">Besoin d'aide&nbsp;?</h2>
          <p class="aside-subtitle">
            Décrivez-nous votre demande, notre équipe vous répond
            <strong>sous 24 à 48h ouvrées</strong>.
          </p>

          <ul class="aside-points">
            <li><i class="pi pi-envelope"></i><span>Réponse personnalisée par email</span></li>
            <li><i class="pi pi-ticket"></i><span>Demande tracée avec un numéro de ticket</span></li>
            <li><i class="pi pi-shield"></i><span>Vos données restent confidentielles</span></li>
          </ul>
        </aside>

        <!-- Formulaire -->
        <section class="help-form-wrapper">
          <div class="form-header">
            <h1 class="form-title">Contactez le support</h1>
            <p class="form-subtitle">Une question, un bug, une demande&nbsp;? On vous aide.</p>
          </div>

          <!-- Bandeau user connecté -->
          <div class="auth-banner" *ngIf="isLoggedIn">
            <i class="pi pi-check-circle"></i>
            <span>
              Connecté en tant que <strong>{{ userName || 'utilisateur' }}</strong>.
              Votre demande sera automatiquement liée à votre compte.
            </span>
          </div>

          <form (ngSubmit)="submit()" novalidate class="help-form">
            <!-- Champs d'identification (non connecté) -->
            <ng-container *ngIf="!isLoggedIn">
              <div class="field">
                <label for="help-email">Email <span class="req">*</span></label>
                <input
                  id="help-email"
                  name="help-email"
                  type="email"
                  pInputText
                  autocomplete="email"
                  placeholder="vous@exemple.com"
                  [(ngModel)]="email"
                  [class.ng-invalid]="submitted && !emailValid"
                  [class.field-error]="submitted && !emailValid"
                />
                <small class="field-msg err" *ngIf="submitted && !emailValid">
                  Une adresse email valide est requise pour vous répondre.
                </small>
              </div>

              <div class="field-row">
                <div class="field">
                  <label for="help-firstname">Prénom</label>
                  <input
                    id="help-firstname"
                    name="help-firstname"
                    type="text"
                    pInputText
                    autocomplete="given-name"
                    placeholder="Jean"
                    [(ngModel)]="firstname"
                  />
                </div>
                <div class="field">
                  <label for="help-lastname">Nom</label>
                  <input
                    id="help-lastname"
                    name="help-lastname"
                    type="text"
                    pInputText
                    autocomplete="family-name"
                    placeholder="Dupont"
                    [(ngModel)]="lastname"
                  />
                </div>
              </div>
            </ng-container>

            <!-- Objet -->
            <div class="field">
              <label for="help-title">
                Objet <span class="req">*</span>
                <span class="counter">{{ title.length }}/{{ titleMaxLength }}</span>
              </label>
              <input
                id="help-title"
                name="help-title"
                type="text"
                pInputText
                [maxlength]="titleMaxLength"
                placeholder="Résumez votre demande en une phrase"
                [(ngModel)]="title"
                [class.field-error]="submitted && !titleValid"
              />
              <small class="field-msg err" *ngIf="submitted && !titleValid">
                L'objet est requis.
              </small>
            </div>

            <!-- Message -->
            <div class="field">
              <label for="help-message">
                Message <span class="req">*</span>
                <span class="counter" [class.counter-warn]="messageCount > 0 && messageCount < messageMinLength">
                  {{ messageCount }} car. min {{ messageMinLength }}
                </span>
              </label>
              <textarea
                id="help-message"
                name="help-message"
                rows="6"
                placeholder="Décrivez votre demande en détail&nbsp;: contexte, étapes pour reproduire, message d'erreur…"
                [(ngModel)]="message"
                [class.field-error]="submitted && !messageValid"
              ></textarea>
              <small class="field-msg err" *ngIf="submitted && !messageValid">
                Le message doit contenir au moins {{ messageMinLength }} caractères.
              </small>
            </div>

            <!-- Erreur globale -->
            <div class="global-error" *ngIf="errorMessage" role="alert" aria-live="assertive">
              <i class="pi pi-exclamation-triangle"></i>
              <span>{{ errorMessage }}</span>
            </div>

            <!-- Submit -->
            <button
              type="submit"
              pButton
              label="Envoyer ma demande"
              icon="pi pi-send"
              iconPos="right"
              [loading]="submitting"
              [disabled]="submitting"
              styleClass="help-submit"
            ></button>

            <p class="legal-note">
              <i class="pi pi-lock"></i>
              En envoyant ce formulaire, vous acceptez d'être recontacté par notre équipe support
              concernant votre demande.
            </p>
          </form>
        </section>
      </ng-container>
    </div>

    <footer class="help-footer">
      <span>&copy; {{ domainName }}</span>
      <span class="dot">•</span>
      <span>Support</span>
    </footer>
  </main>
</div>
